// extracted by mini-css-extract-plugin
export default {"formSection":"MovingDateSection_formSection__gEijC"};